import { useRouter } from 'expo-router';
import { useEffect } from 'react';
import { View } from 'react-native';

import { SignInCard } from '@/components/organisms';
import { useAuthStore } from '@/stores';
import { spacing, useAppTheme } from '@/theme';

export const Login = () => {
  const router = useRouter();
  const { colors } = useAppTheme();
  const error = useAuthStore((state) => state.error);
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const isLoading = useAuthStore((state) => state.isLoading);
  const login = useAuthStore((state) => state.login);

  useEffect(() => {
    if (isLoading) {
      return;
    }

    if (isAuthenticated) {
      router.replace('/');
    }
  }, [isAuthenticated, isLoading, router]);

  return (
    <View
      style={{
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: colors.secondaryContainer,
        paddingHorizontal: spacing[4],
      }}>
      <SignInCard
        key={error?.key ?? 'no-error'}
        error={error}
        isLoading={isLoading}
        onSignIn={login}
      />
    </View>
  );
};
